import { createSlice } from "@reduxjs/toolkit";
import {
    getDashboardCounts, getEmpDashboardCounts
} from './thunk';

export const initialState = {
    dashboardList: [],
    loading: false,
    error: null
};

const UsersSlice = createSlice({
    name: 'Dashboard',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        // getDashboardCounts
        builder.addCase(getDashboardCounts.pending, (state: any) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getDashboardCounts.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.dashboardList = action.payload;
            state.error = null;
        });
        builder.addCase(getDashboardCounts.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || action.error?.message || 'Failed to fetch dashboard data';
        });

        // getEmpDashboardCounts
        builder.addCase(getEmpDashboardCounts.pending, (state: any) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getEmpDashboardCounts.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.dashboardList = action.payload;
            state.error = null;
        });
        builder.addCase(getEmpDashboardCounts.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || action.error?.message || 'Failed to fetch employee dashboard data';
        });
    }
});

export const { clearError } = UsersSlice.actions;
export default UsersSlice.reducer;